import { getLink } from "../../../utils/utils";

import author from "./author";

const content = {
	esp: (
		`
		<p class="mb-3">
			La libro faras strangan efikon.
		</p>
		
		<p>
			Unue, ĝi elvokas triston kaj sopiron pro perdita tempo kaj perdita energio. 
			Perdita en pasinto tempo – jes, nia «ora epoko», kiam Esperanton eklernadis centoj kaj miloj! 
			Perdita energio – ĉar fakte, preskaŭ neniuj el tiuj centoj kaj miloj vere ekposedis la lingvon kaj uzis ĝin en sia kutima vivo. 
			Nu kia utilo estis, ke en Orebro preskaŭ dekono de la loĝantaro partoprenis kursojn? 
			Ĉu venis de tie almenaŭ unu konscia e-isto, komprenanta la ideon de nia lingvo kaj uzanta ĝin por ajna, eĉ distra celo?
		</p>
		
		<p>
			Fakte, post tralego de tiu vere profunda, tre serioze verkita libro, por kiu estis esploritaj tunoj da aŭtentaj dokumentoj, mi enpensiĝis pri la rolo de Cseh-metodo kaj ĝiaj instruistoj. 
			Mi mem havas diplomon de IEI, ne instruis Cseh-metode, ĉar lecionis nur en mia lando, sed konas la metodon kaj sufiĉe aprezis ĝin.
		</p>
		
		<p>
			Sed en la libro, bazita sur profundaj esploroj arkivaj, aperis abunda dokumentado, kiu, eble eĉ nelaŭvole de la verkintino, akre prilumas la staton de Cseh-movado en ĝia «ora tempo». 
			Ekz., en 1936 s-ro Morariu «dum 5-monata kursumado… vojaĝis 8139 km, prelegis antaŭ 1500-membra publiko, gvidis kursojn por 200 komencantoj kaj 100 progresintoj… 
			Pri liaj kursoj aperis en la … gazetoj artikoloj en 65 kolonmetra longo» (p.87). 
			Kiaj rezultoj? 
			Ni primemoru ankaŭ eĉ pli furorajn kursojn de A. Cseh mem, kien strebis miloj…
		</p>
		
		<p>
			Ĉu ne estis tio kvazaŭ artistaj elpaŝoj antaŭ publiko? «Nur laŭte, forte kaj elegante!» – slogano de A. Cseh. 
			Ĉu ne tiel devas agi artisto, sola sur la scenejo altiranta kaj detenanta atenton de la publiko? 
			Ja pri aktoreco senkaŝe diris eĉ la nun-(tiam)-tempa preso (p.32, 37).
		</p>
		
		<p class="mb-3">
			Unuaj Cseh-instruistoj estis brilaj aktoroj (kaj la nunaj ja devas esti tiaj!). 
			Ili ravas publikon, ĉarmigas ĝin, allogas, ekmastras ĝin kaj instigas fari tion, kion ili preskribas. 
			Sed la influo de artisto daŭras nur dum lia koncerto; oni povas daŭre adori lin, sed lian sugeston, se li havis iun, oni apenaŭ sekvos reveninte hejmen. 
			Do, brilaj elpaŝoj allogis publikon, kiu aplaŭdegis – sed ne ĉiuj ja spektantoj de aktoro fariĝas aktoroj! 
			Jen kion ekvidis mi en tiuj zorgeme kolektitaj dokumentoj de la epoko.
		</p>
		
		<p>
			Kaj alia, paralela penso: eble, entute facileco ne estas atuto? 
			Ekmemoru ni pli foran historion: lernadon de t.n. «mortaj lingvoj», la greka kaj latina, en gimnazioj de XIX jc. 
			Estis pena, malfacila studado; oni lernis tiujn lingvojn ne por iu praktika celo, sed ĝuste por alkutimigi la cerbon al konstanta laboro, al streĉiĝo. 
			Kaj rezultoj? 
			Jes, multaj suferis, malamis nebezonatajn, malfacilegajn lingvojn, - sed malgraŭ tio ĉiuj sciis almenaŭ iom, ne povis ne parkerigi ion pro severa altruda studado.
		</p> 
		
		<p class="mb-4">
			Mi tute ne pledas por severa altruda instruado de Eo, kompreneble. 
			Mi nur volas diri, ke facile akirita – facile perdiĝas, kaj aprezas kiel valoraĵon oni kutime tion, kion oni ricevas eluzante iujn fortojn de sia animo. 
			Do, ĉu indas insiste proklami, ke Esperanto estas facila lingvo? 
			Des pli, ke plimulto de e-istoj ne bone posedas ĝin kaj apenaŭ balbutas kun eraroj pri plej ordinaraj temoj?
		</p>
		
		<p>
			Nun pri alia flanko de la libro: la forma, ne enhava.
		</p>
		
		<p>
			Brila ideo estis tiuj diverskoloraj paĝoj: tre bele, elegante kaj elokvente!
		</p>
		
		<p>
			Sed mirigas, ke tiel renoma teamo de lingvaj reviziistoj lasis relative multajn (por tia altranga teamo!) erarojn kaj mistajpojn. Ekz.:
		</p>
		
		<p>
			p.11 – «ĉi tiun ĉi» – ĉu ne multe da ĉi»?
		</p>
		
		<p>
			p.14 – «… fondis «Universala Ligo» – ĉu ne «Universala<span class="bold">n</span> Ligo<span class="bold">n</span>»?
		</p>
		
		<p>
			p.17 – «estis aljuĝita … monata<span class="bold">n</span> honorario<span class="bold">n</span>»
		</p>
		
		<p>
			p.66 – «uzataj en Svedujo<span class="bold">n</span>»
		</p>
		
		<p>
			p.70 – «legu originalaj<span class="bold">n</span> kaj tradukitaj<span class="bold">n</span> literaturaĵoj» – sen <span class="bold">n</span>
		</p>
		
		<p>
			p.73 – «ankoraŭ<span class="bold">u</span>»
		</p>
		
		<p>
			p.78 – «longaj nokto» sen <span class="bold">j</span>
		</p>
		
		<p>
			p.88 – «tio ebligis renkontiĝojn kun <span class="bold">siaj</span> fratino kaj…» – ĉu ne <span class="bold">liaj</span>?
		</p>
		
		<p>
			p.100 – «alvoko, kiu estis dissendita<span class="bold">j</span>»
		</p>
		
		<p>
			p.124 – «poemo el la plumo<span class="bold">j</span>»
		</p>
		
		<p>
			Kaj sur p. 39 konfuziĝis «ĉapeloj» en certa alineo: «vi puri<span class="bold">g</span>os, <span class="bold">ŝ</span>telsignita ordono, proksimi<span class="bold">g</span>as al alia pino»…
		</p>
		
		<p class="mb-4">
			Kompreneble, neniu kredos, ke estas veraj eraroj; certe, mistajpoj; sed ne rajtas ili esti en <i>tia</i> libro.
		</p>
		
		<p>
			La aŭtoro avertas: «Evidentajn tajp- kaj lingvajn erarojn mi markas per krisignoj [!] interkrampaj». 
			Tio koncernas, kompreneble, nur kolorajn paĝojn kun originalaj tekstoj. 
			Sed tie mi, male, vidas tro severan aliron al la afero. 
			Jen, kelkfoje <span class="bold">s</span> estas anstataŭita per <span class="bold">z</span>: p.40 – «Jezuo», p.56 kaj 115 – «Drezdeno» (laŭ sono, verŝajne). 
			Kelkfoje anstataŭ <span class="bold">ĥ</span> estas skribita <span class="bold">k</span> ( tion oni ofte faras eĉ nun): p.58- «monakejo», p.76 – «Ĉekoslovakio» – ĉu tiel gravaj eraroj?
		</p>
		`
	)
}

const itemName = {
	esp: 'Pri la libro de Katalin Kovats «Stelsemantoj en la ora nordo»'
}

const itemBookInfo = {
	esp: {
		bookName: 'Stelamantoj en la ora nordo. Tiberio Morariu kaj liaj samtempuloj',
		content: `
			<p>
				Aŭtoro: Katalin Kovats, <br/>
				E-duKati, Den Haag, 2011, 160 p.
			</p>
		`
	}
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemAuthor: author.esp,
		itemBookInfo: itemBookInfo.esp,
		itemTranslator: `
			El la rusa tradukis Mikaelo Povorin. <br/>
			Literatura suplemento al la gazeto REGO, Moskvo, 2005. 44 p.
		`
	}
}

export default item;